import { AssemblyMemberPart } from '../../../../store/selectors/assemblyPartsUtilities';
import { MemberFilter } from './getMemberFilter';

export function applyMemberFilter(
  assemblyMemberParts: readonly AssemblyMemberPart[],
  memberFilter: MemberFilter,
): readonly AssemblyMemberPart[] {
  return assemblyMemberParts
    .map((assemblyPart) => ({
      ...assemblyPart,
      membersOfCutAndLength: assemblyPart.membersOfCutAndLength
        .map((membersOfCutAndLength) => ({
          ...membersOfCutAndLength,
          componentInfo: membersOfCutAndLength.componentInfo.filter(
            (componentInfo) => memberFilter(componentInfo.members, componentInfo.component).length > 0,
          ),
        }))
        .filter((membersOfCutAndLength) => membersOfCutAndLength.componentInfo.length > 0),
    }))
    .filter((assemblyPart) => assemblyPart.membersOfCutAndLength.length > 0);
}
